import { render } from "./SchoolOverview.vue?vue&type=template&id=150b3d9b&ts=true"
import script from "./SchoolOverview.vue?vue&type=script&lang=ts"
export * from "./SchoolOverview.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__